import Stack from '@mui/material/Stack'
import { useGridRootProps } from '@mui/x-data-grid-pro'

import { DataGridToolbarContainer } from './DataGridToolbarContainer'
import { DataGridToolbarDefaultButtons } from './DataGridToolbarDefaultButtons'

export function DataGridToolbar() {
  const rootProps = useGridRootProps()

  return (
    <DataGridToolbarContainer>
      {rootProps.slotProps?.addButton && (
        <Stack direction='row' spacing={1}>
          <rootProps.slots.addButton {...rootProps.slotProps?.addButton} />
        </Stack>
      )}
      <DataGridToolbarDefaultButtons />
    </DataGridToolbarContainer>
  )
}
